import { Form } from 'antd'
import { useTranslation } from 'react-i18next'

import { formProps } from './utils'
import { OrderMediaActions } from '../OrderMediaActions'

export const MediaStep = () => {
  const { t } = useTranslation()
  const { orderKey } = formProps(t)
  const orderId = Form.useWatch(orderKey.name, { preserve: true })

  return <OrderMediaActions orderId={orderId} />
}
